import React, { useState, useEffect } from "react";
import ChatComponents from "../../pages/ChatComponents";
import ChatLoginGuest from "../../pages/ChatLoginGuest";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ReactPlayer from "react-player";
import { HiUser } from "react-icons/hi";
import axios from "axios";
import { NavLink , useNavigate} from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../../asstes/chat.css"
// import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { toast } from "react-toastify";
export default function SoundchatVideoSection(props) {
  console.log("props soundchat", props )
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");

  const showToastMessage = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const showToastMessageone = (data) => {
    toast.error(data, {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const [LiveVedio, setLiveVedio] = useState({});
  const [videoStatus, setvideoStatus] = useState(true);
  const [guestlogin, setguestlogin] = useState(
    localStorage.getItem("guestlogin")
  );
  useEffect(() => {
    axios
      .post(`https://app.soundchatradio.com:3000/api/v1/auth/listlivecontent`)
      .then((response) => {
        setLiveVedio(response.data.data[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  useEffect(() => {
    if (props.props === "play") {
      setvideoStatus(false);
    } else if (props.props === "pause") {
      setvideoStatus(true);
    }
  }, [props]);

  function handleSubmit(values) {
    axios({
      method: "POST",
      url: "https://app.soundchatradio.com:3000/api/v1/auth/guestsignin",
      data: {
        username: values.username,
      },
    })
      .then((response) => {
        // console.log(response.data);
        if (response.data.status === 400) {
          showToastMessageone(response.data.message);
        } else {
          showToastMessage("Login Guests Login Successfully ");
          setguestlogin(response.data.data.username);
          localStorage.setItem(
            "guestlogin",
            JSON.stringify(response.data.data.username)
          );
          navigate("/",{replace:true});
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  }

  const formik = useFormik({
    initialValues: {
      username: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required!"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
      formik.resetForm();
    },
  });
  return (
    <section className="bg-color">
      <div className="Soundchat-div">
        <div className="container-fluid">
          <Row>
            <Col xs={12} md={6} lg={9}>
              <div className="video-soundchat">
                <div className="video-live-home">
                  <ReactPlayer
                    className="react-player"
                    url={LiveVedio.livelink}
                    width="100%"
                    height="430px"
                    volume={1}
                    auto="true"
                     playing={videoStatus}
                    controls={true}
                    onPlay={() => {
                      console.log("onPlay")
                      localStorage.setItem("videoplayer", true);
                      localStorage.setItem("audioplayer", false);
                    }}
                    
                    onPause={() => {
                      console.log("onPause")
                      localStorage.setItem("videoplayer", false);
                      localStorage.setItem("audioplayer", true);
                    }}
                  />
                </div>
              </div>
            </Col>

            <Col xs={12} md={6} lg={3}>
              <div className={(token || guestlogin) ? "chat-secound":"chat-user"} >
                {/* {token && guestlogin? <div className=""></div>:<></> } */}
                {!token ? (
                  <>
                    {guestlogin === undefined ||
                    guestlogin === "" ||
                    guestlogin === null ? (
                      <>
                        <NavLink to="/Login">
                          <button className="btn-div-chat-login">
                            Login to chat
                          </button>
                        </NavLink>
                        <br /> <br />
                        <p className="div-or">or</p>
                      </>
                    ) : (
                      <></>
                    )}

                    {guestlogin === undefined ||
                    guestlogin === "" ||
                    guestlogin === null ? (
                      <>
                        <form
                          className="form-group"
                          onSubmit={formik.handleSubmit}
                        >
                          <div className="form-group has-search">
                            <span className="user-icon-div">
                              <HiUser />
                            </span>
                            <input
                              placeholder="Enter Guest Username"
                              type="text"
                              name="username"
                              autoComplete="off"
                              value={formik.values.username}
                              onChange={formik.handleChange}
                            />
                            {formik.errors.username &&
                              formik.touched.username && (
                                <p className="errormessage mt-3">
                                  {formik.errors.username}
                                </p>
                              )}
                            <br />
                            <button
                              type="submit"
                              className="btn-div-chat-login new-user-chat-010"
                            >
                              Login as Guest
                            </button>
                          </div>
                        </form>
                      </>
                    ) : (
                      <>
                        <ChatLoginGuest
                          props={() => {
                            setguestlogin(localStorage.getItem("guestlogin"));
                          }}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <ChatComponents />
                  </>
                )}
              </div>


              {/* {(!localStorage.getItem("guestlogin")===undefined) || (localStorage.getItem("guestlogin")==="")? 
                 (<>
                      
                      <div className="chat-user">
                    
                    <NavLink to="/Login">
                      <button className="btn-div-chat-login">
                        Login to chat
                      </button>
                    </NavLink>
                    <br /> <br />
                    <p className="div-or">or</p>
                      <form className="form-group" onSubmit={formik.handleSubmit}>
                      <div className="form-group has-search">
                        <span className="user-icon-div">
                          <HiUser />
                        </span>
                        <input
                          placeholder="Enter Guest User"
                          type="text"
                          name="username"
                          autoComplete="off"
                          value={formik.values.username}
                          onChange={formik.handleChange}
                        />
                        {formik.errors.username && formik.touched.username && (
                          <p className="errormessage mt-3">
                            {formik.errors.username}
                          </p>
                        )}
                        <br />
                        <button
                          type="submit"
                          className="btn-div-chat-login new-user-chat-010"
                        >
                          Login as Guest
                        </button>
                      </div>
                    </form>      
                  </div>
                 </>)
                 :
                 (<><ChatLoginGuest/></>)} */}
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
}

// &&  ((!localStorage.getItem("guestlogin")==="") || (localStorage.getItem("guestlogin")===undefined)))
// </>):(<><ChatLoginGuest/></>)}
